var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-nav"},[(_vm.subjectList)?_c('ul',[_c('li',[_vm._v("学科：")]),_vm._l((_vm.subjectList),function(item,index){return _c('li',{key:index,staticClass:"nav-item",class:_vm.subject === index ? 'activity' : '',on:{"click":function($event){return _vm.changeSubject(index)}}},[_vm._v(" "+_vm._s(item)+" ")])})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }